{
  "$schema": "./schema.json",
  "bids": {
    "companyLoanBid": {
      "amount": "Belopp",
      "paybackTimeMonths": "Löptid",
      "amortizationMethod": "Amorteringstyp",
      "lenderMonthlyInterest": {
        "yearly": "Årsränta (enligt avtalet)",
        "monthly": "Månadsränta (enligt avtalet)"
      },
      "lenderMonthlyAmount": "Fast månadsavgift",
      "averageMonthlyPayment": {
        "title": "Månadsbetalning",
        "helperTitle": "Genomsnittlig månadsbetalning"
      },
      "firstMonthPayment": "Betalning (första månad)",
      "averageMonthlyCost": "Räntekostnad",
      "firstMonthCost": "Räntekostnad",
      "averageMonthlyAmortisation": "Amortering",
      "firstMonthAmortisation": "Amortering",
      "comparableMonthlyInterestRate": "Effektiv månadsränta",
      "comparableYearlyInterestRate": "Effektiv årsränta",
      "firstMonthInterestRate": "Ränta (första månad)",

      "earlyRepaymentFee": "Kostnad för förtidsinlösen",
      "setupFee": "Uppsättningskostnad",
      "administrationFees": "Administrationsavgifter (per månad)",
      "administrationFeesHelperTitle": "Ytterligare månadsavgifter – till exempel autogiroavgift, avi-avgift eller andra administrationsavgifter"
    },
    "factoringBid": {
      "purchaseLimit": "Fakturaköpslimit",
      "purchasedAmountPercent": "Finansieringsgrad (i %)",
      "paymentTermsDays": "dagar",
      "commissionPercent": "Factoringsavgift",
      "withRegress": "Regress",
      "withRegressYes": "Ja",
      "withRegressNo": "Nej",
      "regressNumDaysAfterDueDate": "Regress antal dagar",
      "limitFeePerYearPercent": "Limitavgift (per år)",
      "handlingFeePerInvoice": "Hanteringsavgift per faktura",
      "monthlyFee": "Fast månadsavgift",
      "amount": "Belopp",
      "averageMonthlyCost": "Månadskostnad",
      "firstMonthCost": "Factoringavgift (första månad)",
      "comparableMonthlyInterestRate": "Effektiv månadsränta",
      "comparableYearlyInterestRate": "Effektiv årsränta",
      "firstMonthInterestRate": "Ränta (första månad)",
      "earlyRepaymentFee": "Kostnad för förtidsinlösen",
      "setupFee": "Uppsättningskostnad"
    },
    "realEstateBid": {
      "amount": "Belopp",
      "paybackTimeMonths": "Löptid",
      "amortizationMethod": "Amorteringstyp",
      "lenderMonthlyInterest": {
        "yearly": "Årsränta (enligt avtalet)",
        "monthly": "Månadsränta (enligt avtalet)"
      },
      "lenderMonthlyAmount": "Fast månadsavgift",
      "amortizationDuringTerm": "Amortering under löptiden",
      "amortizationInPercent": "Amortering i procent",
      "averageMonthlyPayment": {
        "title": "Månadsbetalning",
        "helperTitle": "Genomsnittlig månadsbetalning"
      },
      "firstMonthPayment": "Betalning (första månad)",
      "averageMonthlyCost": "Räntekostnad",
      "firstMonthCost": "Räntekostnad",
      "averageMonthlyAmortisation": "Amortering",
      "firstMonthAmortisation": "Amortering",
      "comparableMonthlyInterestRate": "Effektiv månadsränta",
      "comparableYearlyInterestRate": "Effektiv årsränta",
      "firstMonthInterestRate": "Ränta (första månad)",
      "earlyRepaymentFee": "Kostnad för förtidsinlösen",
      "setupFee": "Uppsättningskostnad"
    },
    "leasingBid": {
      "amount": "Belopp",
      "paybackTimeMonths": "Löptid",
      "downPayment": "Första förhöjd hyra",
      "monthlyPayment": {
        "title": "Månadsbetalning",
        "helperTitle": "Genomsnittlig månadsbetalning"
      },
      "firstMonthPayment": "Betalning (första månad)",
      "terminalValue": {
        "title": "Restvärde",
        "description": "Restvärde gäller enbart för finansiell leasing (dvs. inte hyra). Det beskriver det förväntade marknadsvärdet på leasingobjektet vid slutet av leasingperioden. Efter leasingavtalets slut har du möjlighet att köpa loss leasingobjektet genom att betala restvärdet till leasingbolaget."
      },
      "contractType": {
        "label": "Typ av kontrakt",
        "LEASING": {
          "title": "Leasing",
          "description": "Företagsleasing är bra för företag som vill investera i ny eller begagnad utrustning, maskiner eller inredning utan att behöva köpa eller låna. När avtalet löpt ut kan du förlänga avtalet, köpa objektet till ett restvärde eller lämna tillbaka objektet."
        },
        "RENT": {
          "title": "Hyra",
          "description": "Ibland lämpar det sig bättre att hyra istället för att leasa. Framför allt vid de tillfällen då du vill kunna byta ut utrustningen under avtalsperioden. När avtalet löper ut kan du förlänga hyresperioden eller lämna tillbaka objektet."
        }
      },
      "insuranceMonthlyCost": "Försäkringskostnad (per månad)",
      "averageMonthlyCost": "Räntekostnad",
      "firstMonthCost": "Räntekostnad",
      "averageMonthlyAmortisation": "Amortering",
      "firstMonthAmortisation": "Amortering",
      "comparableMonthlyInterestRate": "Effektiv månadsränta",
      "comparableYearlyInterestRate": "Effektiv årsränta",
      "firstMonthInterestRate": "Ränta (första månad)",
      "earlyRepaymentFee": "Kostnad för förtidsinlösen",
      "setupFee": "Uppsättningskostnad",
      "administrationFees": "Administrationsavgifter (per månad)",
      "administrationFeesHelperTitle": "Ytterligare månadsavgifter – till exempel autogiroavgift, avi-avgift eller andra administrationsavgifter"
    },
    "revolvingCreditBid": {
      "amount": "Belopp",
      "lenderMonthlyInterest": {
        "yearly": "Ränta (per år)",
        "monthly": "Ränta (per månad)"
      },
      "monthlyAmortisation": "Amortering (per månad)",
      "withdrawalFee": {
        "title": "Uttagsavgift",
        "description": "Uttagsavgiften betalas vid varje tillfälle där du vill dra ner ytterliga pengar från din finansieringslimit."
      },
      "limitFeePerYear": "Limitavgift (per år)",
      "averageMonthlyPayment": "Månadsbetalning (vid 50% nyttjandegrad)",
      "firstMonthPayment": "Betalning (vid 100% nyttjandegrad)",
      "averageMonthlyCost": "Räntekostnad",
      "firstMonthCost": "Räntekostnad",
      "averageMonthlyAmortisation": "Amortering",
      "firstMonthAmortisation": "Amortering",
      "comparableMonthlyInterestRate": "Effektiv månadsränta",
      "comparableYearlyInterestRate": "Effektiv årsränta",
      "firstMonthInterestRate": "Ränta (första månad)",
      "earlyRepaymentFee": "Kostnad för förtidsinlösen",
      "setupFee": "Uppsättningskostnad",
      "administrationFees": "Administrationsavgifter (per månad)",
      "administrationFeesHelperTitle": "Ytterligare månadsavgifter – till exempel autogiroavgift, avi-avgift eller andra administrationsavgifter"
    },
    "purchaseFinancingBid": {
      "amount": "Kreditgräns",
      "lenderMonthlyInterest": {
        "title": "Ränta per månad",
        "helperTitle": "Räntan beräknas per månad och betalas i sin helhet på förfallodagen.",
        "summaryTitle": "Månadsränta",
        "summaryYearly": "Årsränta",
        "summaryTooltip": "Enligt avtalet"
      },
      "limitFeePerYear": "Limitavgift (per år)",
      "paybackTimeDays": "Återbetalningstid (dagar)",
      "averageMonthlyPayment": {
        "title": "Månadsbetalning",
        "helperTitle": "Genomsnittlig månadsbetalning"
      },
      "firstMonthPayment": "Betalning (första månaden)",
      "averageMonthlyCost": "Räntekostnad",
      "firstMonthCost": "Räntekostnad",
      "averageMonthlyAmortisation": "Amortering",
      "firstMonthAmortisation": "Amortering",
      "comparableMonthlyInterestRate": "Effektiv månadsränta",
      "comparableYearlyInterestRate": "Effektiv årsränta",
      "firstMonthInterestRate": "Ränta (första månad)",
      "setupFee": "Uppsättningskostnad",
      "administrationFees": "Administrationsavgifter (per månad)",
      "administrationFeesHelperTitle": "Ytterligare månadsavgifter – till exempel autogiroavgift, avi-avgift eller andra administrationsavgifter"
    },
    "calculations": {
      "title": "Nyckeltal för ditt erbjudande",
      "monthly": "Månadsvis",
      "firstMonth": "Första månaden",
      "yearly": "Årsvis"
    },
    "common": {
      "repayableWithoutFee": "Kostnadsfri",
      "months": "månader",
      "month": "månad",
      "days": "dagar",
      "lender": "Långivare"
    }
  }
}
